import type { ReactNode } from 'react'

/** Centred card used by every signed-out screen (login, first login, no access). */
export function AuthLayout({ title, subtitle, children }: { title: string; subtitle?: string; children: ReactNode }) {
  return (
    <main className="min-h-dvh bg-page flex flex-col items-center justify-center px-4 py-10">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-3 mb-6 justify-center">
          <span
            aria-hidden="true"
            className="grid place-items-center size-10 rounded-card bg-brand text-white text-section font-semibold"
          >
            +
          </span>
          <span className="text-section font-semibold text-ink">Church Accounts</span>
        </div>
        <div className="bg-surface rounded-2xl border border-line shadow-card p-6 sm:p-8">
          <h1 className="text-title font-semibold text-ink">{title}</h1>
          {subtitle && <p className="mt-1.5 text-body text-muted">{subtitle}</p>}
          <div className="mt-6">{children}</div>
        </div>
      </div>
    </main>
  )
}

/** An error message that screen readers announce as soon as it appears. */
export function FormError({ children }: { children: ReactNode }) {
  return (
    <div role="alert" className="rounded-control border border-bad/30 bg-bad-tint px-3.5 py-3 text-body text-bad">
      {children}
    </div>
  )
}
